import "devextreme/dist/css/dx.common.css";
import "./themes/generated/theme.base.dark.css";
import "./themes/generated/theme.base.css";
import "./themes/generated/theme.additional.dark.css";
import "./themes/generated/theme.additional.css";
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./dx-styles.scss";
import LoadPanel from "devextreme-react/load-panel";
import { NavigationProvider } from "./contexts/navigation";
import { AuthProvider, useAuth } from "./contexts/auth";
import { useScreenSizeClass } from "./utils/media-query";
import Content from "./Content";
import UnauthenticatedContent from "./UnauthenticatedContent";
import { ThemeContext, useThemeContext } from "./theme";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { loginSuccess } from "@redux/slices/authSlice";
import config from 'devextreme/core/config';

function App() {
  const dispatch = useDispatch();
  const { loading, isAuthenticated } = useSelector((state) => state.auth);
  const [checkingAuth, setCheckingAuth] = useState(true); // NEW STATE
  const accessToken = Cookies.get("accessToken");
  const licenseKey = process.env.REACT_APP_DEVEXTREME_LICENSE_KEY;

  config({ licenseKey });



  useEffect(() => {
    if (accessToken) {
      dispatch(loginSuccess({ accessToken }));
    }
    setCheckingAuth(false); // Mark check as complete
  }, [dispatch, accessToken]);

  if (loading || checkingAuth) {
    return <LoadPanel visible={true} />;
  }
  return isAuthenticated ? <Content /> : <UnauthenticatedContent />
}

export default function Root() {
  const screenSizeClass = useScreenSizeClass();
  const themeContext = useThemeContext();

  return (
    <Router>
      <ThemeContext.Provider value={themeContext}>
        <AuthProvider>
          <NavigationProvider>
            <div className={`app ${screenSizeClass}`}>
              <App />
            </div>
          </NavigationProvider>
        </AuthProvider>
      </ThemeContext.Provider>
    </Router>
  );
}
